import { useEffect, useState } from "react";
import { getheader, setErrorDialog } from "../store/api/CommonFunctions";
import { Button } from "react-bootstrap";
import { Bell, BellFill } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";



export const unsubscribePushManager = async () => {
    if (!("serviceWorker" in navigator)) return;

    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        await sub.unsubscribe();
    }

    //setIsEnabled(false); // دکمه فعال‌سازی دوباره نمایش داده شود
};

export default function PushNotificationManager({ currentUser }) {
    const [isEnabled, setIsEnabled] = useState(false);
    const dispatch = useDispatch();

    const registerSW = async () => {
        if (!("serviceWorker" in navigator)) return;

        try {
            const reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
            console.log("SW registered:", reg.scope);
            await subscribeOrRefresh(reg);
        } catch (err) {
            console.error("SW registration failed:", err);
        }
    };

    const requestPermissionAndSubscribe = async () => {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            setErrorDialog(dispatch, "اجازه نمایش اعلان داده نشد!", "نمایش اعلان");
            return;
        }
        const reg = await navigator.serviceWorker.ready;
        await subscribeOrRefresh(reg);
    };

    const subscribeOrRefresh = async (reg) => {
        if (!reg) reg = await navigator.serviceWorker.ready;

        let sub = await reg.pushManager.getSubscription();
        if (sub) {
            const isExpired = sub.expirationTime && Date.now() > sub.expirationTime;
            if (isExpired) {
                await sub.unsubscribe();
                sub = null;
            }
        }

        if (!sub) {
            const serverUrl = localStorage.getItem("ServerUrl");
            if (!serverUrl) {
                return;
            }
            const token = localStorage.getItem('token');
            if (!token) {
                return;
            }
            const publicKey = await fetch(`${serverUrl}/api/ServerEventsAPI/GetPushNotificationPublicKey`, { headers: getheader() })
                .then(r => r.text())
                .then(k => k.replace(/['"]+/g, '').trim());
            const convertedKey = urlBase64ToUint8Array(publicKey);
            sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: convertedKey,
            });
            console.log("New subscription:", sub);
            const subJson = sub.toJSON();
            // ارسال subscription به سرور
            await fetch(`${serverUrl}/api/ServerEventsAPI/SubscribeToPush`, {
                method: 'POST',
                headers: getheader(),
                body: JSON.stringify({
                    endpoint: subJson.endpoint,
                    p256dh: subJson.keys.p256dh,
                    auth: subJson.keys.auth,
                }),
            });
        }

        setIsEnabled(true);
    };

    const urlBase64ToUint8Array = (base64String) => {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
        const rawData = window.atob(base64);
        return new Uint8Array(rawData.length).map((_, i) => rawData.charCodeAt(i));
    };
    useEffect(() => {
  
        if (currentUser)
            registerSW();
        // Listener برای pushsubscriptionchange
        const messageHandler = async (event) => {
            if (!event.data || event.data.type !== "NEW_SUBSCRIPTION") return;
            const sub = event.data.subscription;

            //console.log("NEW_SUBSCRIPTION from SW:", sub);
            const serverUrl = localStorage.getItem("ServerUrl");
            if (!serverUrl) {
                return;
            }
            const token = localStorage.getItem('token');
            if (!token) {
                return;
            }

            // ارسال subscription به سرور
            try {
                await fetch(`${serverUrl}/api/ServerEventsAPI/SubscribeToPush`, {
                    method: 'POST',
                    headers:
                        getheader(),
                    body: JSON.stringify({
                        endpoint: sub.endpoint,
                        p256dh: sub.keys.p256dh,
                        auth: sub.keys.auth,
                    }),
                });
                //console.log("Subscription sent to server successfully");
                setIsEnabled(true);
            } catch (err) {
                console.error("Failed to send subscription", err);
            }
        };

        navigator.serviceWorker.addEventListener("message", messageHandler);

        return () => {
            navigator.serviceWorker.removeEventListener("message", messageHandler);
        };
    }, [currentUser]);

    return (
        <div className="rightTooltip hoverIcon" color="orange" data-tooltip="دسترسی اعلان را فعال کنید" style={{ position: "absolute", zIndex: 2, left: 13, top: 41 }}>
            {!currentUser || isEnabled ? (
                <></>
            ) : (
                <FontAwesomeIcon icon={faBell} size="2x" color="#ff7600" className="bell-icon" />

            )}
        </div>
    );
}
